"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapFinancingInputToFaunaCreateInput = void 0;
const mappers_1 = require("../../utils/mappers");
const mapFinancingInputToFaunaCreateInput = (input) => {
    const mappedInput = mappers_1.FaunaMapper.mapFaunaInput(input);
    return input
        ? {
            create: Object.assign(Object.assign({}, mappedInput), { payments: (input === null || input === void 0 ? void 0 : input.payments) ? { create: mappedInput.payments } : undefined, request: (input === null || input === void 0 ? void 0 : input.request) ? { create: mappedInput.request } : undefined }),
        }
        : undefined;
};
exports.mapFinancingInputToFaunaCreateInput = mapFinancingInputToFaunaCreateInput;
//# sourceMappingURL=financing.js.map